import { loadLogin } from '../auth/localStorage';

const isLocal = () => document.location.host.indexOf('localhost') >= 0;

export const ENV = {
	url: `${process.env.REACT_APP_PROTOCOL}${process.env.REACT_APP_API_URL}`,
	previewUrl: `${process.env.REACT_APP_PROTOCOL}${process.env.REACT_APP_DATABAS_URL}`,
	isLocal,
};

export const RAG_ENV = {
	baseUrl: `${process.env.REACT_APP_PROTOCOL}${process.env.REACT_APP_RAG_API_BASE_URL}`,
	clientId: process.env.REACT_APP_RAG_CLIENT_ID,
	secret: process.env.REACT_APP_RAG_SECRET,
};

export const getHeaders = () => {
	let auth = loadLogin();

	return auth && auth.login
		? {
				accesskey: auth.login.user.accessKey,
				dbkey: auth.login.user.dbKey,
		  }
		: {};
};

export const get = (type, url, stateKey = 'payload', options) => {
	return async (dispatch) => {
		dispatch({
			type: `${type}_BEGIN`,
			payload: options,
		});

		return fetch(`${ENV.url}${url}`, { headers: getHeaders(), method: 'GET' })
			.then((response) => response.json().then((body) => ({ response, body })))
			.then(({ response, body }) => {
				let outcome = response.ok ? 'SUCCESS' : 'FAILURE';
				let result = { type: `${type}_${outcome}` };

				if (response.ok) {
					result[stateKey] = body;
				}

				if (options) {
					Object.keys(options).forEach((key) => (result[key] = options[key]));
				}

				dispatch(result);
			});
	};
};

export const get_v2 = async (url) => {
	let response = await fetch(`${ENV.url}${url}`, { headers: getHeaders(), method: 'GET' });

	if (response.ok) {
		return response.json();
	}

	return {};
};

export const post = (type, url, form) => {
	return async (dispatch) => {
		dispatch({
			type: `${type}_BEGIN`,
		});

		return fetch(`${ENV.url}${url}`, {
			method: 'POST',
			body: form,
			headers: getHeaders(),
		})
			.then((response) => response.json().then((body) => ({ response, body })))
			.then(({ response, body }) => {
				if (!response.ok) {
					dispatch({
						type: `${type}_FAILURE`,
						payload: body,
					});
				} else {
					dispatch({
						type: `${type}_SUCCESS`,
						payload: body,
					});
				}
			})
			.catch((err) => {
				console.dir(err);
				dispatch({
					type: `${type}_FAILURE`,
				});
			});
	};
};

export const postJson = (type, url, body) => {
	return async (dispatch) => {
		dispatch({
			type: `${type}_BEGIN`,
		});

		let headers = getHeaders();
		headers['Accept'] = 'application/json';
		headers['Content-Type'] = 'application/json';

		return fetch(`${ENV.url}${url}`, {
			method: 'POST',
			body: JSON.stringify(body),
			headers,
		})
			.then((response) => response.json().then((body) => ({ response, body })))
			.then(({ response, body }) => {
				if (!response.ok) {
					dispatch({
						type: `${type}_FAILURE`,
						payload: body,
					});
				} else {
					dispatch({
						type: `${type}_SUCCESS`,
						payload: body,
					});
				}
			});
	};
};

export const request = async (method, url, data = null, headers = {}, form = false) => {
	const apiUrl = `${ENV.url}${url}`;
	const defaultHeaders = {
		Accept: ['text/plain', 'application/json'],
		...getHeaders(),
		...headers,
	};

	if (!form) {
		defaultHeaders['Content-Type'] = 'application/json';
	}

	const options = {
		method,
		headers: new Headers(defaultHeaders),
		mode: 'cors',
	};

	if (data) {
		options.body = form ? data : JSON.stringify(data);
	}

	try {
		const response = await fetch(apiUrl, options);

		// Handle non-successful responses (e.g., 404, 500, etc.)
		if (!response.ok) {
			throw new Error(`HTTP Error: ${response.status}`);
		}

		// Check if the response has content
		const contentType = response.headers.get('Content-Type');
		if (contentType && contentType.includes('application/json')) {
			return response.json(); // Only parse JSON if response has JSON content type
		} else {
			return response.ok; // Otherwise return status text or some other placeholder
		}
	} catch (error) {
		// Handle network errors and exceptions
		console.error(`Error calling ${apiUrl}:`, error);
		throw error;
	}
};

export const request_v2 = async (
	method, // "GET", "POST", "PUT", "DELETE", etc.
	baseUrl,
	path,
	data = null,
	headers = {},
	form = false
) => {
	const apiUrl = `${baseUrl}${path}`;

	// Default headers with fallback
	const defaultHeaders = {
		Accept: 'application/json, text/plain',
		...headers,
	};

	// Only add Content-Type if not a form request
	if (!form && method !== 'GET') {
		defaultHeaders['Content-Type'] = 'application/json';
	}

	const options = {
		method,
		headers: defaultHeaders,
		mode: 'cors',
	};

	// Add body only if method allows it
	if (data && method !== 'GET') {
		options.body = form ? data : JSON.stringify(data);
	}

	try {
		const response = await fetch(apiUrl, options);

		// Handle non-successful responses
		if (!response.ok) {
			throw new Error(`HTTP Error: ${response.status}`);
		}

		// Return JSON if applicable, otherwise just return raw response
		const contentType = response.headers.get('Content-Type');
		if (contentType && contentType.includes('application/json')) {
			return await response.json();
		} else {
			return await response.text();
		}
	} catch (error) {
		console.error(`Error calling ${apiUrl}:`, error);
		throw error;
	}
};



// WEBPACK FOOTER //
// ./src/utils/http.js